import * as React from 'react';
import b_ from 'b_';

import './index.scss';

const b = b_.with('risk-icon');

//@translate
export type RiskIconLevel = 'LOW' | 'MEDIUM' | 'HIGH' | 'MEDIUM/HIGH';

interface Props {
  level: RiskIconLevel;
  shaped?: boolean;
  className?: string;
  filled?: boolean;
}

class RiskIcon extends React.Component<Props> {
  render() {
    const { level, shaped, filled } = this.props;
    return (
      <span
        className={b('', {
          level: level.toLowerCase().replace('/', '-'),
          shaped,
          filled,
        })}
      />
    );
  }
}

export default RiskIcon;
